import { render, staticRenderFns } from "./GestaoCargaFilterBar.vue?vue&type=template&id=56cf60d4"
import script from "./GestaoCargaFilterBar.vue?vue&type=script&lang=js"
export * from "./GestaoCargaFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports